<template>
  <div>
    <div class="box">
      <el-page-header
        @back="$router.go(-1)"
        :content="content"
      ></el-page-header>
    </div>
    <el-card class="content mt20 bbb">
      <el-form
        label-position="left"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item :label="$t('serviceCommentList.active')" prop="active">
          <el-radio-group v-model="ruleForm.active">
            <el-radio :label="0">{{
              $t("serviceCommentList.active0")
            }}</el-radio>
            <el-radio :label="1">{{
              $t("serviceCommentList.active1")
            }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          :label="$t('serviceCommentList.user_name')"
          prop="user_name"
        >
          <el-input
            show-word-limit
            v-model="ruleForm.user_name"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('serviceCommentList.service_name')"
          prop="service_name"
        >
          <el-input
            show-word-limit
            v-model="ruleForm.service_name"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('serviceCommentList.content1')"
          prop="row1.content"
        >
          <el-input
            show-word-limit
            v-model="ruleForm.row1.content"
          ></el-input>
          <el-radio-group v-model="ruleForm.row1.is_bold">
            <el-radio :label="0">{{
              $t("serviceCommentList.is_bold0")
            }}</el-radio>
            <el-radio :label="1">{{
              $t("serviceCommentList.is_bold1")
            }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          :label="$t('serviceCommentList.content2')"
          prop="row2.content"
        >
          <el-input
            show-word-limit
            v-model="ruleForm.row2.content"
          ></el-input>
          <el-radio-group v-model="ruleForm.row2.is_bold">
            <el-radio :label="0">{{
              $t("serviceCommentList.is_bold0")
            }}</el-radio>
            <el-radio :label="1">{{
              $t("serviceCommentList.is_bold1")
            }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          :label="$t('serviceCommentList.content3')"
          prop="row3.content"
        >
          <el-input
            show-word-limit
            v-model="ruleForm.row3.content"
          ></el-input>
          <el-radio-group v-model="ruleForm.row3.is_bold">
            <el-radio :label="0">{{
              $t("serviceCommentList.is_bold0")
            }}</el-radio>
            <el-radio :label="1">{{
              $t("serviceCommentList.is_bold1")
            }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <el-button class="btn" type="primary" @click="submitForm('ruleForm')">{{
        $t("btnTip.submit")
      }}</el-button>
    </el-card>
  </div>
</template>
<script>
import { commentDetail, addComment, editComment } from "@/api/api";
export default {
  name: "editComment",
  data() {
    return {
      ruleForm: {
        active: 0,
        user_name: "",
        service_name: "",
        row1: {
          content: "",
          is_bold: 0,
        },
        row2: {
          content: "",
          is_bold: 0,
        },
        row3: {
          content: "",
          is_bold: 0,
        },
      },
      rules: {
        active: [
          {
            required: true,
            message: this.$t("serviceCommnentList").active,
            trigger: "blur",
          },
        ],
        user_name: [
          {
            required: true,
            message: this.$t("serviceCommnentList").user_name,
            trigger: "blur",
          },
        ],
        service_name: [
          {
            required: true,
            message: this.$t("serviceCommnentList").service_name,
            trigger: "blur",
          },
        ],
        // 'row1.content': [
        //     { required: true, message: this.$t('serviceCommnentList').content1, trigger: 'blur' },
        // ],

        // 'row2.content': [
        //     { required: true, message: this.$t('serviceCommnentList').content2, trigger: 'blur' },
        // ],

        // 'row3.content': [
        //     { required: true, message: this.$t('serviceCommnentList').content3, trigger: 'blur' },
        // ],
      },
    };
  },
  computed: {
    id() {
      return Number.isNaN(Number(this.$route.query.id))
        ? undefined
        : Number(this.$route.query.id);
    },
    content() {
      return this.id === undefined
        ? this.$t("btnTip").add
        : this.$t("btnTip").edit;
    },
  },
  methods: {
    async submitForm(formName) {
      await this.$refs[formName].validate();
      if (this.id === undefined) {
        await addComment(this.ruleForm);
      } else {
        delete this.ruleForm.create_time;
        await editComment(this.ruleForm);
      }
      this.$router.go(-1);
    },
    async get_info() {
      const information = await commentDetail(this.id);
      this.ruleForm = { ...information };
    },
  },
  async created() {
    if (this.id === undefined) return;
    this.get_info();
  },
};
</script>
<style land="scss" scoped>
.el-date-editor {
  margin-right: 10px;
}
.bbb {
  position: relative;
  padding-bottom: 50px;
}
.bbb .btn {
  position: absolute;
  bottom: 10px;
  right: 20px;
}
</style>
